import { IconProps } from ".";

export const ContainerIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.48887 4.4981H11.0426H9.48887ZM7.63917 4.4981H9.19292H7.63917ZM5.82647 4.4981H7.38022H5.82647ZM4.01376 4.4981H5.53052H4.01376ZM2.16406 4.4981H3.71781H2.16406ZM4.01376 2.74905H5.53052H4.01376ZM5.82647 2.74905H7.38022H5.82647ZM7.63917 2.74905H9.19292H7.63917ZM7.63917 1H9.19292H7.63917Z"
        fill="currentColor"
      />
      <path
        d="M9.48887 4.4981H11.0426M7.63917 4.4981H9.19292M5.82647 4.4981H7.38022M4.01376 4.4981H5.53052M2.16406 4.4981H3.71781M4.01376 2.74905H5.53052M5.82647 2.74905H7.38022M7.63917 2.74905H9.19292M7.63917 1H9.19292"
        stroke="currentColor"
        strokeWidth="1.44487"
      />
      <path
        d="M16 4.57453C16 4.57453 15.3341 3.92814 13.9653 4.15628C13.8174 3.05361 12.6705 2.40723 12.6705 2.40723C12.6705 2.40723 11.5977 3.73802 12.3746 5.22091C12.1526 5.33498 11.7827 5.48707 11.2278 5.48707H1.05443C0.869457 6.20951 0.869457 11.0004 5.97463 11.0004C9.63703 11.0004 12.3746 9.25133 13.6694 6.05742C15.5931 6.20951 16 4.57453 16 4.57453Z"
        fill="currentColor"
      />
      <g clipPath="url(#clip0_16017_13541)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.9821 12C14.6742 12 12 14.75 12 18.1521C12 20.8716 13.7134 23.1736 16.0904 23.9884C16.3876 24.0496 16.4964 23.856 16.4964 23.6931C16.4964 23.5505 16.4867 23.0616 16.4867 22.5522C14.8226 22.919 14.476 21.8189 14.476 21.8189C14.2086 21.1059 13.8124 20.9226 13.8124 20.9226C13.2677 20.5457 13.852 20.5457 13.852 20.5457C14.4562 20.5865 14.7732 21.1772 14.7732 21.1772C15.308 22.1143 16.1696 21.8495 16.5163 21.6865C16.5658 21.2892 16.7243 21.0142 16.8927 20.8615C15.5655 20.7189 14.1691 20.1892 14.1691 17.8261C14.1691 17.1539 14.4066 16.6039 14.783 16.1761C14.7236 16.0234 14.5156 15.3918 14.8425 14.5464C14.8425 14.5464 15.3476 14.3834 16.4865 15.1779C16.9741 15.0432 17.477 14.9747 17.9821 14.9741C18.4872 14.9741 19.0021 15.0455 19.4776 15.1779C20.6166 14.3834 21.1217 14.5464 21.1217 14.5464C21.4487 15.3918 21.2405 16.0234 21.1811 16.1761C21.5674 16.6039 21.7952 17.1539 21.7952 17.8261C21.7952 20.1892 20.3988 20.7086 19.0616 20.8615C19.2796 21.055 19.4677 21.4216 19.4677 22.0022C19.4677 22.8272 19.4579 23.4894 19.4579 23.693C19.4579 23.856 19.5669 24.0496 19.8639 23.9885C22.2409 23.1735 23.9543 20.8716 23.9543 18.1521C23.9641 14.75 21.2802 12 17.9821 12Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M19.5 7L19.9051 8.09486L21 8.5L19.9051 8.90514L19.5 10L19.0949 8.90514L18 8.5L19.0949 8.09486L19.5 7Z"
        fill="currentColor"
      />
      <path
        d="M6.5 14L7.17523 15.8248L9 16.5L7.17523 17.1752L6.5 19L5.82477 17.1752L4 16.5L5.82477 15.8248L6.5 14Z"
        fill="currentColor"
      />
      <defs>
        <clipPath id="clip0_16017_13541">
          <rect width="12" height="12" fill="currentColor" transform="translate(12 12)" />
        </clipPath>
      </defs>
    </svg>
  );
};
